export { default, loader, LoadingFallback } from "~/components/seo/PageSEO";

export const seo = true;
